import { createQueryKeys } from "@lukemorales/query-key-factory";
import { useMutation, useQueryClient } from "@tanstack/vue-query";
import axios from "axios";
import { UserOrdersApi } from "mws-finance-ts-sdk";
import { OrdersApi } from "mws-ts-v2-sdk";

import { orderQueryKeys } from "~/queries/finance/orders";

let ordersApi: OrdersApi;
let userOrdersApi: UserOrdersApi;

const getOrdersApi = () => {
  // reduce memory overhead by only using one instance
  if (!ordersApi) {
    ordersApi = new OrdersApi(
      undefined,
      useRuntimeConfig().public.financeServiceUrl,
      axios,
    );
  }

  return ordersApi;
};

const getUserOrdersApi = () => {
  // reduce memory overhead by only using one instance
  if (!userOrdersApi) {
    userOrdersApi = new UserOrdersApi(
      undefined,
      useRuntimeConfig().public.financeServiceUrl,
      axios,
    );
  }

  return userOrdersApi;
};

export const framingOrdersQueryKeys = createQueryKeys("framingOrders", {
  canOrderBeFramed: (orderId: MaybeRef<string>) => ({
    queryKey: [orderId],
    queryFn: async () => {
      const response = await getOrdersApi().v2OrdersOrderIdCanBeFramedGet({
        orderId: unref(orderId),
      });

      return response.data;
    },
  }),
});

export const useExpireCurrentUserOrderFramingWindowMutation = () => {
  const queryClient = useQueryClient();
  const { isLoggedIn } = useAuth();
  const { userId } = useUser();
  const platformStore = usePlatformStore();

  return useMutation({
    mutationFn: async (orderId: string) => {
      const response =
        await getUserOrdersApi().ordersOrderIdFramingWindowDelete({
          orderId,
        });

      return response.data;
    },
    onSuccess: (order) => {
      if (isLoggedIn.value && userId.value) {
        queryClient.invalidateQueries({
          queryKey: orderQueryKeys.listForCurrentUser(userId.value, {
            xPlatformKey: platformStore.getPlatformConfiguration.platformId,
          }).queryKey,
        });
      }
      queryClient.invalidateQueries({
        queryKey: framingOrdersQueryKeys.canOrderBeFramed(order.id).queryKey,
      });
    },
  });
};
